import { ReactNode } from 'react';
import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconPicture from '@/icons/Picture.svg';

export const RequestMediumAddedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'request_medium_added'>;
}) => {
  const creatorName = activity.creator?.name ?? '';

  let requestMediaAddedMessage: ReactNode;

  if (activity.data.type === 'proof-of-external-payment') {
    requestMediaAddedMessage = (
      <Trans id="activities.request_medium_added.proof-of-external-payment">
        <strong>{creatorName}</strong> added a receipt / invoice to the request
      </Trans>
    );
  }

  if (!requestMediaAddedMessage) return null;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconPicture />}
      message={<BaseActivityText>{requestMediaAddedMessage}</BaseActivityText>}
    />
  );
};
